MOVE.MORTGAGE.CONSTANTS = (function () {

  var VU_VIDEO_TITLE = 'Brad Barr, Air Force Veteran and Proud Homeowner';

  MOVE.MORTGAGE.CONSTANTS =
  {
    VU_VIDEO_TITLE: VU_VIDEO_TITLE
  };
  return MOVE.FormatHelper.constantize(MOVE.MORTGAGE.CONSTANTS);

})();



// WEBPACK FOOTER //
// ./mortgage/constants.js